<label class="radio-label">
  <input type="radio" #radio [name]="name" [value]="value" [tabindex]="tabindex" [checked]="checked"
    [autofocus]="autofocus" [disabled]="disabled"
    (change)="onChange($any($event.target).value)" />
  <span [style.font-size.px]="fontSize">{{label}}</span>
</label>
